// You can customize the template with the help of this file

import blackLogo from '@src/assets/images/newLogo/black-logo.svg';
import whiteLogo from '@src/assets/images/newLogo/white-logo.svg';
import logoIcon from '@src/assets/images/newLogo/logo-icon.svg';

//Template config options
const themeConfig = {
  app: {
    appLogoLight: blackLogo,
    appLogoImage: whiteLogo,
    faviconImage: logoIcon,
    faviconLight: logoIcon,
    darkicon: whiteLogo,
    lighticon: blackLogo,
  },
  layout: {
    isRTL: false,
    skin: 'light', // light, dark, bordered, semi-dark
    routerTransition: 'fadeIn', // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: 'vertical', // vertical, horizontal
    contentWidth: 'full', // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: true,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: 'floating', // static , sticky , floating, hidden
      backgroundColor: 'white', // BS color options [primary, success, etc]
    },
    footer: {
      type: 'static', // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
  },
};

export default themeConfig;
